// useProject.ts
import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { useProjectId } from '../useProjectId';
import { DbProject } from '~src/types/db';
import { loadProject } from '~src/services/api';

export const useProject = (
  param1?:
    | boolean
    | (QueryConfig<DbProject, AxiosError> & { enabled?: boolean }),
  param2?: boolean,
  param3: QueryConfig<DbProject, AxiosError> & { enabled?: boolean } = {}
) => {
  let extended_project_data: boolean | undefined;
  let extended_contract_data: boolean | undefined;
  let queryConfig: QueryConfig<DbProject, AxiosError> & { enabled?: boolean };

  // Check if the first argument is an object. If so, it's a config object.
  if (typeof param1 === 'object' && param1 !== null) {
    // This logic handles the problematic call: useProject({ enabled: false })
    extended_project_data = undefined;
    extended_contract_data = undefined;
    queryConfig = param1;
  } else {
    // This handles all correct calls: useProject(), useProject(true, true), etc.
    extended_project_data = param1;
    extended_contract_data = param2;
    queryConfig = param3;
  }

  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled === undefined ? true : enabled;

  const projectQuery = useQuery<DbProject, AxiosError>(
    ['project', { projectId, extended_project_data, extended_contract_data }],
    loadProject,
    {
      enabled: !!(enabledOverwrite && projectId), // Ensures a true/false value
      refetchOnWindowFocus: false,
      ...options,
    }
  );

  return projectQuery;
};
